import React from 'react'
import { ScrollView } from 'react-native'
import { EmptyVariant } from 'src/components/DNA/Empty/DNAEmpty'

import {
  DNABox,
  Iffy,
  util,
} from '@alucio/lux-ui'

import DNADocumentGridList from 'src/components/DNA/GridList/DNADocumentGridList'
import DNAGrid from 'src/components/DNA/Grid/DNAGrid'

import {
  useAllDocuments,
} from 'src/state/redux/selector/document'
import useDisplayMode, { DisplayModes } from 'src/components/DNA/hooks/useDisplayMode'
import { useSort, withSort } from 'src/components/DNA/hooks/useSort'
import documentQuery from 'src/state/redux/document/query'
import useFixedHeader from '@alucio/lux-ui/src/hooks/useFixedLayout'
import { useAppSettings } from 'src/state/context/AppSettings'
import { useCPMPageRoute } from 'src/components/ContentPreviewModalV2/Util/useCPMDedicatedUrl'
import { TitleBar } from 'src/components/DNA'
import CenteredGridLayout from 'src/components/CenteredLayout/CenteredGridLayout'

const filter = documentQuery.merge(
  documentQuery.filters.published,
  documentQuery.filters.bookmarked,
)

const useBookmarks = () => {
  const { displayMode, displayModeIconName, toggleDisplayMode } = useDisplayMode(DisplayModes.list, { manageURL: true })
  const { sortSelectorOpts } = useSort()
  const documents = useAllDocuments({ ...filter, ...sortSelectorOpts })

  return {
    documents,
    displayMode,
    displayModeIconName,
    toggleDisplayMode,
  };
}

export const DNABookmarksDeskTop: React.FC = () => {
  const { documents, displayMode, toggleDisplayMode } = useBookmarks();
  const fixedHeaderWidth = useFixedHeader();

  return (
    <DNABox
      fill
      appearance="col"
      spacing="md"
      style={util.mergeStyles(
        undefined,
        [{ maxWidth: fixedHeaderWidth }, displayMode === DisplayModes.grid],
      )}
    >
      {/* Header */}
      <DNABox fill style={{ maxWidth :  fixedHeaderWidth }}>
        <TitleBar
          title="Favorite Files"
          testID="page-title"
          description="Browse your favorite content"
          showToggleView
          toggleView={{
            activeView: displayMode,
            onToggle: toggleDisplayMode,
          }}
        />
      </DNABox>
      {/* Content */}
      <Iffy is={displayMode === DisplayModes.list}>
        <DNADocumentGridList
          documents={documents}
          emptyVariant={EmptyVariant.DocumentGridBookmark}
        />
      </Iffy>
      <Iffy is={displayMode === DisplayModes.grid}>
        <DNAGrid
          items={documents}
          emptyVariant={EmptyVariant.DocumentGridBookmark}
        />
      </Iffy>
    </DNABox>
  );
}

export const DNABookmarksTablet: React.FC = () => {
  const { documents, displayMode, toggleDisplayMode } = useBookmarks();

  return (
    <DNABox fill>
      <DNABox fill appearance="col">
        {/* Header */}
        <DNABox>
          <TitleBar
            title="Favorite Files"
            testID="page-title"
            description="Browse your favorite content"
            showToggleView
            toggleView={{
              activeView: displayMode,
              onToggle: toggleDisplayMode,
            }}
          />
        </DNABox>
        <DNABox fill style={{ overflow: 'scroll' }}>
          <DNABox appearance="col" fill style={{ minWidth: 'fit-content' }}>
            {/* LIST CONTENT */}
            <Iffy is={displayMode === DisplayModes.list}>
              <DNADocumentGridList
                documents={documents}
                emptyVariant={EmptyVariant.DocumentGridBookmark}
              />
            </Iffy>
            {/* GRID CONTENT */}
            <Iffy is={displayMode === DisplayModes.grid}>
              <DNABox as={ScrollView} fill appearance="col" spacing="md">
                <CenteredGridLayout itemWidth={276 + 16} itemCount={documents.length}>
                  <DNAGrid
                    items={documents}
                    emptyVariant={EmptyVariant.DocumentGridBookmark}
                  />
                </CenteredGridLayout>
              </DNABox>
            </Iffy>
          </DNABox>
        </DNABox>
      </DNABox>
    </DNABox>
  );
}

const DNABookmarksSwitcher: React.FC = () => {
  const { deviceMode } = useAppSettings()
  useCPMPageRoute()

  return deviceMode === 'desktop'
    ? <DNABookmarksDeskTop />
    : <DNABookmarksTablet />
}

export default withSort(DNABookmarksSwitcher)
